import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Checkbox, DirectionalHint, Icon, SearchBox, TooltipHost } from 'office-ui-fabric-react';
import React, { useCallback, useContext, useEffect, useState } from 'react';
import { BiInfoCircle } from 'react-icons/bi';
import { FaRegQuestionCircle } from 'react-icons/fa';
import { arrayMoveImmutable } from 'array-move';
import { WsSalesSolutionAction, WsSalesSolutionItem } from '../../../core';
import { getSalesAreas, newItem, newAction } from './helpers';
import { getChildItemsFromTopLevelItems, getItemSizeDescription } from './SolutionComponents';
import { WsSalesSolutionDeliverableClass, WsSalesSolutionOfferingRoleClass, WsSalesSolutionRiskClass, WsSalesSolutionToolClass, WsSalesSolutionWorkProductClass } from '../../../core-sales';
import { getActionById, getItemByActionId, getItemById } from './SolutionView-helpers';
import { getAreaCssBackgroundColor, getAreaCssColor, getActionCssBackgroundColor, getCapabilityEffort, getActionEffort } from '../../../core/sales-items';
import { getPermissionLevel } from "../../../helpers-roles";
import { WsAppContext } from "../../AppContext";
import { getComplexity } from "./SolutionSteps";
import { WsSalesSolutionContext } from "../SalesSolutionContext";
import { getActionExpanded, getAllMetrics, getAllMetricsByItem, getChildItems, getItemExpanded, isActionNotSelected, isActionSelected, isAnyActionSelected, isAnyItemAndActionSelected, itemIsAction, itemIsCapability, setItemProperty, setItemSelected } from '../../../helpers/item-helpers';
import { findItemById} from '../../../core/sales-actions';
import { WsPanelContext } from '../SalesContainerWithPanel';
import { WsSalesSolutionViewContext } from '../SalesSolutionViewContext';
import { WsSelectItemDialog } from './ActionDependencies';
import { WsSalesSolutionDescription } from './SolutionTable';
import './SolutionView.scss';
import { WsPortalContext } from "../../PortalContext";




// TODO: remove
const areas = getSalesAreas();




const adminNewActionPaddingLeft = (item: WsSalesSolutionItem | WsSalesSolutionAction) => {

  if (item.expanded) {

    if (item.actions && Array.isArray(item.actions) && item.actions.length > 0) {
      return '0px';

    } else {
      return '85px';
    }

  } else {
    return '85px';
  }
};



const canExpandCollapse = (item: WsSalesSolutionItem, mode: string) => {
  if (mode === 'size') {
    return false;

  } else if (mode === 'admin') {
    return true;

  } else if ([ 'details', 'proposal', 'contract' ].includes(mode)) {

    return (
      (item.items && Array.isArray(item.items) && item.items.length > 0) ||
      (item.actions && Array.isArray(item.actions) && item.actions.length > 0)
    );

  } else {
    return item.items && Array.isArray(item.items) && item.items.length > 0;
  }
};



const getItemSelected = (item: WsSalesSolutionItem) => {

  // if (item.items && Array.isArray(item.items) && item.items.length > 0) {

  //   let allSelected = true;

  //   item.items.forEach((i: WsSalesSolutionItem) => {
  //     if (getItemSelected(i) !== 1) {
  //       allSelected = false;
  //     }
  //   });

  //   let allNotSelected = true;

  //   item.items.forEach((i: WsSalesSolutionItem) => {
  //     if (getItemSelected(i) !== 0) {
  //       allNotSelected = false;
  //     }
  //   });

  //   if (allSelected) {
  //     return 1;
  //   } else if (allNotSelected) {
  //     return 0;
  //   } else {
  //     return -1;
  //   }

  // } else {
  //   return item.selected ? 1 : 0;
  // }

  // TODO: what is going on here? should the above code be removed?

  return item.selected ? 1 : 0;
};




type WsSalesSolutionBlockSelectedProps = {
  items: WsSalesSolutionItem[];
  setItems: React.Dispatch<React.SetStateAction<WsSalesSolutionItem[]>>;
  item: WsSalesSolutionItem;
  mode: string;
};

const WsSalesSolutionBlockSelected = ({ items, setItems, item, mode }: WsSalesSolutionBlockSelectedProps) => {

  const portalContext = useContext(WsPortalContext);

  const selected = getItemSelected(item);

  return (
    <div className={ getItemExpanded(item, mode) ? 'ws-sales-solution-box-selected ws-sales-solution-box-selected-left' : 'ws-sales-solution-box-selected' }>
      <Checkbox
        // indeterminate={selected === -1 ? true : false }

        onChange={(ev?: React.FormEvent<HTMLElement | HTMLInputElement> | undefined, checked?: boolean | undefined): void => {
          const nextItems = [ ...items ];

          const s = selected === 1 ? false : true;


          if (s) {
            // select
            console.log('select');

            const selectResult = setItemSelected(s, item, mode, nextItems, { selectChildCapabilities: getItemExpanded(item, mode) ? false : true });

            if (Array.isArray(selectResult) && selectResult.length > 0) {

              let linkList = '';
  
              selectResult.forEach((itemFind) => {
                linkList = linkList + `${itemFind.path}/${itemFind.item.name}\n`.slice(1).replace(/\//g, ' / ');
              });
  
              portalContext?.setAlert({ className: 'ws-linked-capabilities-alert-dialog', text: `You selected capabilities that are linked to other capabilities.\n\nFollowing linked capabilities have been selected:\n\n${linkList}`, buttons: { ok: true } });
            }


          } else {
            // unselect
            console.log('unselect');

            const l: any[] = [];

            const x = items.forEach((i) => {
              l.push(...getChildItems(i, 'capabilities', { includeChildCapabilities: true, filterSelectedCapabilities: false }));
            });

            // console.log(l);

            const y = l.filter((a) => {

              const listItem       = a[0];
              const listItemParent = a[1];

              // console.log(listItem);

              if (listItem.linkIds.includes(item.id)) {
                return true;
              } else {
                return false;
              }
            });

            if (y.length > 0) {

              let linkList = '';
  
              y.forEach((a) => {

                const listItem       = a[0];
                const listItemParent = a[1];

                const itemFind = findItemById(items, listItem.id, '', {});

                if (itemFind) {
                  linkList = linkList + `${itemFind.path}/${itemFind.item.name}\n`.slice(1).replace(/\//g, ' / ');
                }
              });

              portalContext?.setAlert({ className: 'ws-linked-capabilities-alert-dialog', text: `This capability cannot be unselected because it is linked to following capabilities:\n\n${linkList}`, buttons: { ok: true } });

            } else {
              const selectResult = setItemSelected(s, item, mode, nextItems, { selectChildCapabilities: getItemExpanded(item, mode) ? false : true });
            }
          }


          setItems(nextItems);
        }}

        checked={selected === 1 ? true : false }
      />
    </div>
  );
};


const getItemSizeSelected = (itemSize: string | undefined, size: string) => {
  if (size === 'S') {
    return 'S' === itemSize;
  } else if (size === 'M') {
    return 'M' === itemSize;
  } else if (size === 'C') {
    return 'C' === itemSize;
  } else if (size === 'VC') {
    return 'VC' === itemSize;
  } else {
    return false;
  }
};


const setItemSize = (items: WsSalesSolutionItem[], setItems: React.Dispatch<React.SetStateAction<WsSalesSolutionItem[]>>, item: WsSalesSolutionItem, itemSize: string) => {
  const newItems = [ ...items ];
  item.size = itemSize;
  setItems(newItems);
};

const getItemSizeAll = (items: WsSalesSolutionItem[], size: string, mode: string) => {

  let value = true;

  items.forEach((item) => {

    if (item.items && Array.isArray(item.items) && item.items.length > 0) {
      const selected = getItemSizeAll(item.items, size, mode);
      if (!selected) {
        value = false;
      }
    }

    if (item.selected) {
      if (item.size !== size) {
        value = false;
      }
    }
  });

  return value;
};


const setItemSizeAll = (items: WsSalesSolutionItem[], setItems: React.Dispatch<React.SetStateAction<WsSalesSolutionItem[]>>, size: string, mode: string) => {

  const newItems = [ ...items ];

  items.forEach((item) => {

    if (item.items && Array.isArray(item.items) && item.items.length > 0) {
      setItemSizeAll(item.items, setItems, size, mode);
    }

    if (item.selected) {
      item.size = size;
    }
  });

  setItems(newItems);

};


const getItemSize = (size: string | undefined) => {
  if (size === 'S') {
    return 'S';
  } else if (size === 'M') {
    return 'M';
  } else if (size === 'C') {
    return 'C';
  } else if (size === 'VC') {
    return 'VC';
  } else {
    return false;
  }
};

const getItemSizeEffort = (itemSize: string | undefined) => {
  if (itemSize === 'S') {
    return 160;
  } else if (itemSize === 'M') {
    return 250;
  } else if (itemSize === 'C') {
    return 400;
  } else if (itemSize === 'VC') {
    return 600;
  } else {
    return 0;
  }
};


type WsSalesSolutionBlockSizeProps = {
  items: WsSalesSolutionItem[];
  setItems: React.Dispatch<React.SetStateAction<WsSalesSolutionItem[]>>;
  item: WsSalesSolutionItem;
};

const WsSalesSolutionBlockSize = ({ items, setItems, item }: WsSalesSolutionBlockSizeProps) => {

  return (
    <div className="ws-sales-solution-box-size">
      <Checkbox
        checked={getItemSizeSelected(item.size, 'S')}
        onChange={(ev?: React.FormEvent<HTMLElement | HTMLInputElement> | undefined, checked?: boolean | undefined) => {
          setItemSize(items, setItems, item, 'S');
        }}
      />
      <Checkbox
        checked={getItemSizeSelected(item.size, 'M')}
        onChange={(ev?: React.FormEvent<HTMLElement | HTMLInputElement> | undefined, checked?: boolean | undefined) => {
          setItemSize(items, setItems, item, 'M');
        }}
      />
      <Checkbox
        checked={getItemSizeSelected(item.size, 'C')}
        onChange={(ev?: React.FormEvent<HTMLElement | HTMLInputElement> | undefined, checked?: boolean | undefined) => {
          setItemSize(items, setItems, item, 'C');
        }}
      />
      <Checkbox
        checked={getItemSizeSelected(item.size, 'VC')}
        onChange={(ev?: React.FormEvent<HTMLElement | HTMLInputElement> | undefined, checked?: boolean | undefined) => {
          setItemSize(items, setItems, item, 'VC');
        }}
      />

      {
        item.sizeDescription.S
        ?
        <>
          <TooltipHost
            content={getItemSizeDescription(item.sizeDescription)}
            id={`ws-sales-solution-item-size-tooltip-${item.id}`}
            directionalHint={DirectionalHint.leftCenter}
            calloutProps={{
              // className: 'ws-sales-solution-item-size-tooltip-callout',
              style: {
                width: '200px'
              }
            }}
          >
            <BiInfoCircle
              aria-describedby={`ws-sales-solution-item-size-tooltip-${item.id}`}
              style={{
                fontSize: '16px',
                verticalAlign: 'middle',
                marginLeft: '5px',
                marginTop: '-9px'
              }}
            />
          </TooltipHost>
        </>
        :
        <div style={{
          display: 'inline-block',
          width: 21,
          height: 14
        }}></div>
      }
    </div>
  );
};


const anyItemSelected = (item: WsSalesSolutionItem) => {

  let value = false;

  if (item.items && Array.isArray(item.items) && item.items.length > 0) {
    item.items.forEach((i: WsSalesSolutionItem) => {
      if (anyItemSelected(i)) {
        value = true;
      }
    });
  }

  if (item.selected) {
    value = true;
  }

  return value;
};




const getMaxLevel = (items: WsSalesSolutionItem[], level: number, mode: string) => {

  let value = level;

  items.forEach((i: WsSalesSolutionItem) => {

    let maxLevel = i.items && Array.isArray(i.items) && i.items.length > 0 ? getMaxLevel(i.items, level + 1, mode) : level;

    if (
      (mode === 'size' && anyItemSelected(i))
      ||
      mode === 'admin'
      ||
      i.expanded
    ) {

      if (maxLevel > value) {
        value = maxLevel;
      }
    }
  });

  return value;
};




const getBlockRightMargin = (items: WsSalesSolutionItem[], level: number, mode: string) => {
  let value = 0;
  const maxLevel = getMaxLevel(items, 1, mode);
  const maxValue = maxLevel * 10;
  value = maxValue - level * 10;

  return value;
};




type WsSalesSolutionBlockRomProps = {
  items: WsSalesSolutionItem[];
  setItems: React.Dispatch<React.SetStateAction<WsSalesSolutionItem[]>>;
  item: WsSalesSolutionItem;
};

const WsSalesSolutionBlockRom = ({ items, setItems, item }: WsSalesSolutionBlockRomProps) => {

  return (
    <div className="ws-sales-solution-box-rom">
      <div className="ws-sales-solution-box-rom-size">{ getItemSelected(item) === 1 && item.size && getItemSize(item.size) }</div>
      <div className="ws-sales-solution-box-rom-effort">{ getItemSelected(item) === 1 && item.size && getItemSizeEffort(item.size) }</div>
      <div className="ws-sales-solution-box-rom-team">Avanade</div>
    </div>
  );
};




const getActionRightMargin = (level: number, mode?: string) => {
  if (mode === 'admin') {
    if (level === 1) {
      return 40;
    } else if (level === 2) {
      return 30;
    } else if (level === 3) {
      return 20;
    } else if (level === 4) {
      return 10;
    } else {
      return 0;
    }
  } else {
    if (level === 1) {
      return 20;
    } else if (level === 2) {
      return 10;
    } else {
      return 0;
    }
  }
};



// TODO: refactor

const getActionScope_need_fix = (actions: WsSalesSolutionAction[] | undefined, onlySelected: boolean) => {
  let list: string[] = [];

  if (actions && Array.isArray(actions) && actions.length > 0) {

    actions.forEach((action: WsSalesSolutionAction) => {

      if (action.actions && Array.isArray(action.actions) && action.actions.length > 0) {

        list = list.concat(getActionScope_need_fix(action.actions, onlySelected));

      } else {
        if (onlySelected) {
          if (action.selected) {
            list.push(action.id);
          }
        } else {
          list.push(action.id);
        }
      }
    });
  }

  return list;
};

// TODO: refactor

const getItem_Scope_need_fix = (item: WsSalesSolutionItem, onlySelected: boolean) => {
  let value = 0;

  if (item.selected) {
    if (item.actions && Array.isArray(item.actions) && item.actions.length > 0) {
      value = value + getActionScope_need_fix(item.actions, onlySelected).length;
    }
  }

  if (item.items && Array.isArray(item.items) && item.items.length > 0) {
    item.items.forEach((i) => {
      value = value + getItem_Scope_need_fix(i, onlySelected);
    });
  }

  return value;
};


const createActionsWrapper = (item: WsSalesSolutionItem) => {

  const actions: WsSalesSolutionAction[] | undefined = item.actions;

  // TODO: improvements to the wrapper

  if (actions && Array.isArray(actions) && actions.length > 0) {

    const list: WsSalesSolutionAction[] = [];

    const action = newAction();
    action.name = 'Scope';
    action.actions = [ ...actions ];
    action.expanded = false;

    action.scopeCapabilityId = item.id;

    list.push(action);

    // console.log(list);

    return list;
  } else {
    return undefined;
  }
};


const setActionSelected = (items: WsSalesSolutionItem[], setItems: React.Dispatch<React.SetStateAction<WsSalesSolutionItem[]>>, action: WsSalesSolutionAction, selected: boolean) => {

  if (action.actions && Array.isArray(action.actions) && action.actions.length > 0) {

    action.actions.forEach((a: WsSalesSolutionAction) => {
      setActionSelected(items, setItems, a, selected);
    });

  }

  const newItems = [ ...items ];
  action.selected = selected;
  setItems(newItems);
};



const getGrayedOutStyleForButtons = (style: any, setColor: boolean) => {
  const s = { ...style };

  if (!setColor) {
    s['color'] = '#cacaca';
  }

  return s;
}


type WsSalesSolutionBlockActionsProps = {
  items: WsSalesSolutionItem[];
  setItems: React.Dispatch<React.SetStateAction<WsSalesSolutionItem[]>>;
  mode: string;
  level: number;
  levelActions: WsSalesSolutionAction[] | undefined;
  levelItem?: any;
  expanded?: boolean | undefined; // TODO: investigate - why do we need this?
  isTopLevelActions?: boolean;

  // showAction: WsSalesSolutionItem | WsSalesSolutionAction | undefined; // TODO: this can be item or action
  // setShowAction: React.Dispatch<React.SetStateAction<WsSalesSolutionItem | WsSalesSolutionAction | undefined>>;

  // editAction: any; // WsSalesSolutionItem | WsSalesSolutionAction | undefined // TODO: this can be item or action
  // setEditAction: React.Dispatch<React.SetStateAction<WsSalesSolutionItem | WsSalesSolutionAction | undefined>>;
};

const WsSalesSolutionBlockActions = ({ items, setItems, mode, level, levelActions, levelItem, expanded, isTopLevelActions }: WsSalesSolutionBlockActionsProps) => {

  const appContext = useContext(WsAppContext);
  const panelContext = useContext(WsPanelContext);
  const permissionLevelParnerSubmit = [ 'PARTNER_SUBMIT' ].includes(getPermissionLevel('sales/solution', appContext?.role));
  const permissionLevelFull =         [ 'FULL'           ].includes(getPermissionLevel('sales/solution', appContext?.role));
  const [ actionsExpanded, setActionsExpanded ] = useState<boolean>(false);

  // const [ showAction, setShowAction ] = useState<WsSalesSolutionAction | undefined>(undefined);
  // const [ editAction, setEditAction ] = useState<WsSalesSolutionAction | undefined>(undefined);


  const onClickShowAction = useCallback(async (item: WsSalesSolutionAction) => {
    console.log(`click : action : ${item?.name || 'none'}`);

    if (item.name === 'Scope') {
      console.log(item);
      alert('Something went wrong!');
    } else {
      panelContext.setShowAction(item);
    }
  }, [ panelContext.setShowAction ]);



  const components: JSX.Element[] = [];

  (levelActions ? levelActions : []).forEach((action: WsSalesSolutionAction, actionIndex: number) => {
    const rightMarging = getActionRightMargin(level, mode);
    // const actionExpanded = getActionExpanded(action, mode); // isTopLevelActions ? actionsExpanded : getActionExpanded(action, mode);
    const actionExpanded = isTopLevelActions ? actionsExpanded : getActionExpanded(action, mode);
    const parentItem = getItemByActionId(items, action.id);

    if (
      (
        mode === 'scope'    ||
        mode === 'size'     ||
        mode === 'rom'      ||
        mode === 'details'  ||
       (mode === 'proposal' && (action.selected || isAnyActionSelected(action))) ||
       (mode === 'contract' && (action.selected || isAnyActionSelected(action))) ||
        mode === 'admin'
      )
      && expanded
    ) {
      components.push(
        <div
          className="ws-sales-solution-action-box"
          style={{
            backgroundColor: getActionCssBackgroundColor(level),
            color: '#3d3d3d'
          }}
          key={`ws-sales-solution-block-${action.id}`}
        >

          <div className="ws-sales-solution-action" style={{ marginRight: rightMarging }}>

            <div
              className="ws-sales-solution-action-name"
              onClick={() => {
                if (isTopLevelActions) {
                  if (actionsExpanded) {
                    setActionsExpanded(false);
                  } else {
                    setActionsExpanded(true);
                  }
                } else { 
                  if (action.actions && Array.isArray(action.actions) && action.actions.length > 0) {
                    const nextItems = [ ...items ];
                    action.expanded = action.expanded ? false : true; // TODO: should this be using actionExpanded?
                    setItems(nextItems);
                  }
                }
              }}
            >
              {
                action.actions && Array.isArray(action.actions) && action.actions.length > 0
                ?
                <>
                  { actionExpanded ? <FontAwesomeIcon icon={['far', 'minus-square']} /> : <FontAwesomeIcon icon={['far', 'plus-square']} /> } {action.name}
                </>
                :
                <>{action.name}</>
              }
              {
                action.description
                &&
                <>
                  <WsSalesSolutionDescription itemId={action.id} itemDescription={action.description} />
                </>
              }
            </div>

            {
              mode === 'admin'
              ?
              <>
                {
                  action.name !== 'Scope' // TODO: improvements to the wrapper
                  &&
                  <div className="ws-sales-solution-admin">

                    {
                      action.metrics && Array.isArray(action.metrics) && action.metrics.length > 0
                      ?
                      <div className="ws-sales-solution-admin-indicator"><b>METRICS:</b> {action.metrics.length}</div>
                      :
                      null // <div className="ws-sales-solution-admin-indicator"><b>METRICS:</b> 0</div>
                    }

                    {
                      (action.children && action.children.filter((c) => c instanceof WsSalesSolutionDeliverableClass).length > 0)
                      &&
                      <div className="ws-sales-solution-admin-indicator"><b>DELIVERABLES:</b> { action.children.filter((c) => c instanceof WsSalesSolutionDeliverableClass).length }</div>
                    }

                    {
                      (action.children && action.children.filter((c) => c instanceof WsSalesSolutionWorkProductClass).length > 0)
                      &&
                      <div className="ws-sales-solution-admin-indicator"><b>WORK PRODUCTS:</b> { action.children.filter((c) => c instanceof WsSalesSolutionWorkProductClass).length }</div>
                    }

                    {
                      (action.children && action.children.filter((c) => c instanceof WsSalesSolutionOfferingRoleClass).length > 0)
                      &&
                      <div className="ws-sales-solution-admin-indicator"><b>ROLES:</b> { action.children.filter((c) => c instanceof WsSalesSolutionOfferingRoleClass).length }</div>
                    }

                    {
                      (action.children && action.children.filter((c) => c instanceof WsSalesSolutionToolClass).length > 0)
                      &&
                      <div className="ws-sales-solution-admin-indicator"><b>TOOLS:</b> { action.children.filter((c) => c instanceof WsSalesSolutionToolClass).length }</div>
                    }

                    {
                      (action.children && action.children.filter((c) => c instanceof WsSalesSolutionRiskClass).length > 0)
                      &&
                      <div className="ws-sales-solution-admin-indicator"><b>RISKS:</b> { action.children.filter((c) => c instanceof WsSalesSolutionRiskClass).length }</div>
                    }

                    {
                      action.dependencies && Array.isArray(action.dependencies) && action.dependencies.length > 0
                      ?
                      <div className="ws-sales-solution-admin-indicator"><b>DEPENDENCIES:</b> {action.dependencies.length}</div>
                      :
                      null // <div className="ws-sales-solution-admin-indicator"><b>DEPENDENCIES:</b> 0</div>
                    }

                    {
                      action.assumptions && Array.isArray(action.assumptions) && action.assumptions.length > 0
                      ?
                      <div className="ws-sales-solution-admin-indicator"><b>ASSUMPTIONS:</b> {action.assumptions.length}</div>
                      :
                      null // <div className="ws-sales-solution-admin-indicator"><b>ASSUMPTIONS:</b> 0</div>
                    }

                    <Icon className="ws-sales-solution-admin-edit" iconName={'PageEdit'} onClick={() => {
                      panelContext.setEditAction(action);
                    }} />

                    <Icon className="ws-sales-solution-admin-delete" iconName={'Movers'} style={getGrayedOutStyleForButtons({ marginLeft: '10px' }, actionIndex > 0)} onClick={() => {
                      const nextItems = [ ...items ];

                      if (parentItem && parentItem.actions && Array.isArray(parentItem.actions) && parentItem.actions.length > 0) {
                        if (actionIndex > 0) {
                          parentItem.actions = arrayMoveImmutable(parentItem.actions, actionIndex, actionIndex - 1);
                        } else {
                          // alert('Cannot move!');
                        }
                      }

                      setItems(nextItems);
                    }} />

                    <Icon className="ws-sales-solution-admin-delete" iconName={'DrillDown'} style={getGrayedOutStyleForButtons({ marginLeft: '5px' }, (parentItem && parentItem.actions && (actionIndex < parentItem.actions.length - 1) ? true : false))} onClick={() => {
                      const nextItems = [ ...items ];

                      if (parentItem && parentItem.actions && Array.isArray(parentItem.actions) && parentItem.actions.length > 0) {
                        if (actionIndex < parentItem.actions.length - 1) {
                          parentItem.actions = arrayMoveImmutable(parentItem.actions, actionIndex, actionIndex + 1);
                        } else {
                          // alert('Cannot move!');
                        }
                      }

                      setItems(nextItems);
                    }} />

                    {/* <Icon className="ws-sales-solution-admin-delete ws-mirror" iconName={'TurnRight'} style={{ marginLeft: '7px', marginRight: '2px' }} onClick={() => {
                      // const nextItems = [ ...items ];

                      // if (parentItem && parentItem.actions && Array.isArray(parentItem.actions) && parentItem.actions.length > 0) {
                      //   if (actionIndex < parentItem.actions.length - 1) {
                      //     parentItem.actions = arrayMoveImmutable(parentItem.actions, actionIndex, actionIndex + 1);
                      //   } else {
                      //     // alert('Cannot move!');
                      //   }
                      // }

                      // setItems(nextItems);
                    }} /> */}

                    <Icon className="ws-sales-solution-admin-delete" iconName={'Delete'} onClick={() => {
                      const answer = window.confirm(`Delete Action: ${action.name}?`);

                      if (answer) {

                        const nextItems = [ ...items ];

                        const nextItem = getItemByActionId(nextItems, action.id);
  
                        if (nextItem && nextItem.actions && Array.isArray(nextItem.actions) && nextItem.actions.length > 0) {
                          nextItem.actions = nextItem.actions.filter((a: WsSalesSolutionAction) => a.id !== action.id);
                        }
  
                        setItems(nextItems);

                      } else {
                        // cancel
                      }
                    }} />
                  </div>
                }
              </>
              :
              <>
                <div className="ws-sales-solution-action-metrics">
                  {
                    getAllMetrics([ action ], true).length > 0
                    ?
                    <Icon
                      className="ws-sales-solution-action-metrics-icon"
                      iconName={'Settings'} // Error // AlertSettings
                      onClick={(e: any) => {
                        e.preventDefault();
                        onClickShowAction(action);
                      }}
                    />
                    :
                    <Icon
                      className="ws-sales-solution-action-metrics-icon"
                      iconName={'Info'}
                      onClick={(e: any) => {
                        e.preventDefault();
                        onClickShowAction(action);
                      }}
                    />
                  }
                </div>

                <div className="ws-sales-solution-action-scope-in">
                  <Checkbox
                    label="IN"
                    checked={isActionSelected(action)}
                    onChange={(ev?: React.FormEvent<HTMLElement | HTMLInputElement> | undefined, checked?: boolean | undefined) => {
                      setActionSelected(items, setItems, action, true);
                    }}
                    disabled={ mode === 'proposal' || mode === 'contract' }
                  />
                </div>

                <div className="ws-sales-solution-action-scope-out">
                  <Checkbox
                    label="OUT"
                    checked={isActionNotSelected(action)}
                    onChange={(ev?: React.FormEvent<HTMLElement | HTMLInputElement> | undefined, checked?: boolean | undefined) => {
                      setActionSelected(items, setItems, action, false);
                    }}
                    disabled={ mode === 'proposal' || mode === 'contract' }
                  />
                </div>

                <div className="ws-sales-solution-action-scope-effort">
                  {
                    permissionLevelFull
                    &&
                    <>{getActionEffort(action, { includeChildActions: true })}h</>
                  }
                </div>
              </>
            }

          </div>

          <WsSalesSolutionBlockActions
            items={items}
            setItems={setItems}
            mode={mode}
            level={level + 1}
            levelActions={action.actions}
            levelItem={action}
            expanded={actionExpanded}
            isTopLevelActions={false}
          />
        </div>
      );
    }
  });



  if (
    mode === 'admin'
    &&
    // level > 1
    // &&
    levelItem
  ) {

    if (levelItem.name === 'Scope') {
      // don't show for scope action

    } else {

      components.push(
        <div
          className="ws-sales-solution-action-box"
          style={{
            marginTop: '0px',
            marginLeft: '5px',
            paddingLeft: adminNewActionPaddingLeft(levelItem)
            // textAlign: levelItem.expanded ? 'left' : 'right',
            // backgroundColor: getAreaCssBackgroundColor(item.areaId, level),
            // color: getAreaCssColor(item.areaId, level)
          }}
          key={`ws-sales-solution-block-new`}
        >

          <div className="ws-sales-solution-action">

            <div
              className="ws-sales-solution-action-name"
              onClick={() => {
                const nextItems = [ ...items ];

                const a = newAction();
                a.effort = 0;
                a.expanded = true;

                const itemOrAction = isTopLevelActions ? getItemById(nextItems, levelItem.id) : getActionById(nextItems, levelItem.id);

                if (itemOrAction) {

                  if (itemOrAction.actions) {
                    itemOrAction.actions.push(a);
                  } else {
                    itemOrAction.actions = [ a ];
                  }

                  itemOrAction.expanded = true;

                  setActionsExpanded(true);
                }

                setItems(nextItems);
              }}
            >
              <Icon iconName={'CircleAdditionSolid'} style={{ fontSize: '17px', verticalAlign: 'middle', marginTop: '-2px' }}/> Add New Action (to {levelItem.name})
            </div>
          </div>
        </div>
      );
    }
  }


  if (components.length > 0) {
    return (
      <div className="ws-sales-solution-actions">
        <div className={ `ws-sales-solution-box-level ws-sales-solution-box-level-${level}` }>
          {components}
        </div>
      </div>
    );
  } else {
    return null;
  }
};


type WsSalesSolutionBlockProps = {
  items: WsSalesSolutionItem[];
  setItems: React.Dispatch<React.SetStateAction<WsSalesSolutionItem[]>>;
  mode: string;
  level: number;
  levelItems?: WsSalesSolutionItem[];
  levelItem?: WsSalesSolutionItem;
  avanade: boolean;
  searchItemId?: string | undefined;
};

const WsSalesSolutionBlockContainer = ({ items, setItems, mode, level, levelItems, levelItem, avanade, searchItemId }: WsSalesSolutionBlockProps) => {

  const appContext = useContext(WsAppContext);
  const panelContext = useContext(WsPanelContext);
  const solutionContext = useContext(WsSalesSolutionContext);
  const solutionViewContext = useContext(WsSalesSolutionViewContext);
  const permissionLevelParnerSubmit = [ 'PARTNER_SUBMIT' ].includes(getPermissionLevel('sales/solution', appContext?.role));
  const permissionLevelFull =         [ 'FULL'           ].includes(getPermissionLevel('sales/solution', appContext?.role));


  const onClickShowAction = useCallback(async (item: WsSalesSolutionItem | WsSalesSolutionAction | undefined) => {
    // console.log(`click : item : ${item?.name || 'none'}`);
    // console.log(item);
    panelContext.setShowAction(item);
  }, [ panelContext.setShowAction ]);



  const components: JSX.Element[] = [];

  (levelItems ? levelItems : (levelItem && levelItem.items && Array.isArray(levelItem.items) ? levelItem.items : [])).forEach((item: WsSalesSolutionItem, itemIndex: number) => {

    if (
       mode === 'scope'                                         ||
      (mode === 'size'     && anyItemSelected(item))            ||
      (mode === 'rom'      && anyItemSelected(item))            ||
      (mode === 'details'  && anyItemSelected(item))            ||
      (mode === 'proposal' && isAnyItemAndActionSelected(item)) ||
      (mode === 'contract' && isAnyItemAndActionSelected(item)) ||
       mode === 'admin'
    ) {

      const rightMarging = getBlockRightMargin(items, level, mode);

      let itemDescription = item.description;

      // TODO: remove legacy description

      if (!itemDescription) {

        // console.warn('item description missing');

        const capability: any | undefined = solutionContext.salesCapabilitiesConfig.find((c: any) => item.areaId && areas[item.areaId] && c.Area === areas[item.areaId].name && c.Name === item.name);

        if (capability && capability.Description) {
          console.warn(`using legacy description for ${item.name}`);
          itemDescription = capability.Description;
        }
      }



      const highligthSearchItem = searchItemId === item.id;



      components.push(
        <div
          id={`ws-capability-${item.id}`}
          className={ highligthSearchItem ? 'ws-sales-solution-box ws-sales-solution-highlight' : 'ws-sales-solution-box' }
          style={{
            backgroundColor: getAreaCssBackgroundColor(item.areaId, level),
            color: getAreaCssColor(item.areaId, level)
          }}
          key={`ws-sales-solution-block-${item.id}`}
        >

          <div className="ws-sales-solution-box-top">

            {/* **** */}
            {/* name */}
            <div
              className="ws-sales-solution-box-name"
              onClick={() => {
                if (canExpandCollapse(item, mode)) {
                  const nextItems = [ ...items ];
                  item.expanded = item.expanded ? false : true;
                  setItems(nextItems);
                }
              }}
            >
              {
                canExpandCollapse(item, mode)
                ?
                <>
                  { getItemExpanded(item, mode) ? <FontAwesomeIcon icon={['far', 'minus-square']} /> : <FontAwesomeIcon icon={['far', 'plus-square']} /> } {item.name}
                </>
                :
                <>
                  {item.name}
                </>
              }
              <>
                {
                  itemDescription
                  &&
                  <WsSalesSolutionDescription itemId={item.id} itemDescription={itemDescription} />
                }
              </>
            </div>

            {/* name */}
            {/* **** */}




            {/* ******* */}
            {/* options */}

            {
              mode === 'scope' // && canExpandCollapse(item, mode)
              &&
              <>
                { getItemExpanded(item, mode) && <WsSalesSolutionBlockSelected items={items} setItems={setItems} item={item} mode={mode} /> }

                {
                  <div className="ws-sales-solution-box-options" style={{ marginRight: rightMarging }}>

                    { !getItemExpanded(item, mode) && <WsSalesSolutionBlockSelected items={items} setItems={setItems} item={item} mode={mode} /> }

                  </div>
                }
              </>
            }

            {
              mode === 'size' && item.selected
              &&
              <>
                <div className="ws-sales-solution-box-options" style={{ marginRight: rightMarging }}>
                  <WsSalesSolutionBlockSize items={items} setItems={setItems} item={item} />
                </div>
              </>
            }

            {
              mode === 'rom'
              &&
              <>
                <div className="ws-sales-solution-box-options" style={{ marginRight: rightMarging }}>
                  <WsSalesSolutionBlockRom items={items} setItems={setItems} item={item} />
                </div>
              </>
            }

            {
              [ 'details', 'proposal', 'contract' ].includes(mode)
              &&
              <>
                <>
                  <div className="ws-sales-solution-box-options" style={{ marginRight: rightMarging }}>
                    <div className="ws-sales-solution-box-metrics">
                      <div className="ws-sales-solution-box-metrics-button">
                        {
                          getAllMetricsByItem(item, true).length > 0
                          ?
                          <Icon
                            className="ws-sales-solution-action-metrics-icon"
                            iconName={'Settings'} // Error // AlertSettings
                            onClick={(e: any) => {
                              e.preventDefault();
                              onClickShowAction(item);
                            }}
                          />
                          :
                          <Icon
                            className="ws-sales-solution-action-metrics-icon"
                            iconName={'Info'}
                            onClick={(e: any) => {
                              e.preventDefault();
                              onClickShowAction(item);
                            }}
                          />
                        }
                      </div>
                      <div className="ws-sales-solution-box-metrics-scope">
                        In Scope - {getItem_Scope_need_fix(item, true)} { mode === 'details' && <>of {getItem_Scope_need_fix(item, false)}</> }
                      </div>
                      <div className="ws-sales-solution-box-metrics-effort">
                        {
                          permissionLevelFull
                          &&
                          <>{getCapabilityEffort(item, getComplexity(solutionContext.salesProcess), { includeChildCapabilities: true })}h</>
                        }
                      </div>
                    </div>
                  </div>
                </>
              </>
            }

            {
              mode === 'admin'
              &&
              level > 1
              &&
              <>
                <div className="ws-sales-solution-box-options" style={{ marginRight: rightMarging }}>
                  <div className="ws-sales-solution-admin">

                    <Icon className="ws-sales-solution-admin-edit" iconName={'PageEdit'} onClick={() => {
                      panelContext.setEditAction(item);
                    }} />

                    <Icon className="ws-sales-solution-admin-delete ws-mirror" iconName={'TurnRight'} style={{ marginLeft: '7px', marginRight: '2px' }} onClick={() => {
                      // const nextItems = [ ...items ];

                      // if (parentItem && parentItem.actions && Array.isArray(parentItem.actions) && parentItem.actions.length > 0) {
                      //   if (actionIndex < parentItem.actions.length - 1) {
                      //     parentItem.actions = arrayMoveImmutable(parentItem.actions, actionIndex, actionIndex + 1);
                      //   } else {
                      //     // alert('Cannot move!');
                      //   }
                      // }

                      // setItems(nextItems);

                      solutionViewContext.setMoveItem(item);

                    }} />

                    <Icon className="ws-sales-solution-admin-delete" iconName={'Delete'} onClick={() => {
                      const answer = window.confirm(`Delete Capability: ${item.name}?`);

                      if (answer) {
                        const nextItems = [ ...items ];

                        if (levelItem && levelItem.items && Array.isArray(levelItem.items) && levelItem.items.length > 0) {
                          levelItem.items = levelItem.items.filter((i: WsSalesSolutionItem) => i.id !== item.id);
                        }

                        setItems(nextItems);

                      } else {
                        // cancel
                      }
                    }} />
                  </div>
                </div>
              </>
            }

            {/* options */}
            {/* ******* */}
          </div>


          {/* ***** */}
          {/* actions */}

          {
            (
              (
                [ 'details', 'proposal', 'contract' ].includes(mode) && getItemExpanded(item, mode) && item.selected
              )
              ||
              (
                [ 'admin' ].includes(mode) && getItemExpanded(item, mode)
              )
            )
            &&
            <div className="ws-sales-solution-box-bottom">
              {
                // item.actions && Array.isArray(item.actions) // && item.actions.length > 0
                // &&
                <div className="ws-sales-solution-box-items">
                  <WsSalesSolutionBlockActions
                    items={items}
                    setItems={setItems}
                    mode={mode}
                    level={1}
                    levelActions={createActionsWrapper(item)}
                    levelItem={item}
                    expanded={true}
                    isTopLevelActions={true}
                  />
                </div>
              }
            </div>
          }

          {/* actions */}
          {/* ***** */}


          {/* ***** */}
          {/* items */}

          {
            getItemExpanded(item, mode)
            &&
            <div className="ws-sales-solution-box-bottom">
              {
                // item.items && Array.isArray(item.items) && item.items.length > 0
                // &&
                <div className="ws-sales-solution-box-items">
                  <WsSalesSolutionBlockContainer
                    items={items}
                    setItems={setItems}
                    mode={mode}
                    level={level + 1}
                    levelItem={item}
                    avanade={avanade}
                    searchItemId={searchItemId}
                  />
                </div>
              }
            </div>
          }

          {/* items */}
          {/* ***** */}
          

        </div>
      );
    }
  });



  // admin

  if (mode === 'admin' && levelItem && level < 8) {

    components.push(<div
      className="ws-sales-solution-box"
      style={{
        marginLeft: 0,
        // textAlign: 'right',
        // backgroundColor: getAreaCssBackgroundColor(item.areaId, level),
        // color: getAreaCssColor(item.areaId, level)
      }}
      key={`ws-sales-solution-block-new`}
    >

      <div className="ws-sales-solution-box-top">

        <div
          className="ws-sales-solution-box-name"
          onClick={() => {
            const nextItems = [ ...items ];
            
            const i = newItem();
            i.areaId = levelItem.areaId;

            if (levelItem.items) {
              levelItem.items.push(i);
            } else {
              levelItem.items = [ i ];
            }

            setItems(nextItems);
          }}
        >
          <Icon iconName={'CircleAdditionSolid'} style={{ fontSize: '17px', verticalAlign: 'middle', marginTop: '-2px' }}/> Add New Capability
        </div>
      </div>
    </div>);
  }



  // return

  return (
    <div className={ `ws-sales-solution-box-level ws-sales-solution-box-level-${level}` }>
      {components}

      {/* {
        displayAction
        &&
        <WsSalesSolutionPanel
          items={items}
          setItems={setItems}
          mode={mode}
          showAction={showAction}
          setShowAction={setShowAction}
          editAction={editAction}
          setEditAction={setEditAction}
          metrics={displayActionMetrics}
          requireScope={false}
          avanade={avanade}
        />
      } */}
    </div>
  );
};




const sizeDescription: { [ key: string ]: any } = {
  'S':  (<><b>Small (S)</b> - recommended for solutions that have straightforward business requirements.</>),
  'M':  (<><b>Medium (M)</b> - provides flexibility in configuration to align with specific business requirements.</>),
  'C':  (<><b>Complex (C)</b> - address more complex business requirements with advanced functionalities.</>),
  'VC': (<><b>Very Complex (VC)</b> - requires in-depth analysis, planning, extended implementation and large-scale deployments.</>)
};


const WsItemSizeTooltip = (props: { children: any, size: string }) => {

  return (
    <div className="ws-sales-solution-item-size-tooltip">
      <div className="ws-sales-solution-item-size-tooltip-host">
        <TooltipHost
          id={`ws-sales-solution-item-size-tooltip-${props.size}`}
          content={ sizeDescription[props.size] }
          // directionalHint={DirectionalHint.leftTopEdge}
          calloutProps={{
            className: 'ws-sales-solution-item-size-tooltip-callout',
            // style: {
            //   width: '280px'
            // }
          }}
        >
          <FaRegQuestionCircle
            aria-describedby={`ws-sales-solution-item-size-tooltip-${props.size}`}
            className="ws-sales-solution-item-size-tooltip-icon"
          />
          <div className="ws-sales-solution-item-size-tooltip-size">{props.size}</div>
        </TooltipHost>
      </div>
      {props.children}
    </div>
  );
};




const getItemPath = (items: WsSalesSolutionItem[], item: WsSalesSolutionItem) => {

  const itemFind = findItemById(items, item.id, '', {});

  if (itemFind) {

    // const itemPath = `${itemFind.path}/${itemFind.item.name}`;

    // const modelName = itemPath.slice(1).replace(/\//g, ' / ');

    return itemFind.path.slice(1).replace(/\//g, ' / ');

  } else {
    return '';
  }

  // if (dependencyId) {
  //   const findAction = findActionById(items, undefined, dependencyId, '', { filterSelected: false, includeChildActions: true });
  //   if (findAction) {
  //     return findAction.path.slice(1).replace(/\//g, ' / ');
  //   } else {
  //     return 'Error: not found!';
  //   }
  // } else {
  //   return 'Select Dependency (Action)';
  // }
};




const ItemNameWithSearch = (props: { name: string, search: string, item: WsSalesSolutionItem, mode: string, items: WsSalesSolutionItem[], setItems: React.Dispatch<React.SetStateAction<WsSalesSolutionItem[]>> }) => {

  // if (`${props.name}`.toLowerCase().indexOf(`${props.search}`.toLowerCase()) > -1) {

  //   const x = props.name.split(props.search);

  //   if (x.length === 2) {
  //     return <>{x[0]}<b>{props.search}</b>{x[1]}</>;

  //   } else {
  //     return <>{x[0]}<b>{props.search}</b>{x[1]}</>;
  //   }

  // } else {
  //   return <>{props.name}</>;
  // }

  // const selected = getItemSelected(props.item);

  return (
    <>
      {props.name}
    </>
  );
};






const expandItems = (items: WsSalesSolutionItem[] | undefined, expandItemId: string) => {
  let value: WsSalesSolutionItem | undefined = undefined;

  if (items && Array.isArray(items) && items.length > 0) {

    items.forEach((item) => {

      if (item.id === expandItemId) {

        value = item;

      } else {

        const itemExpand = expandItems(item.items, expandItemId);

        if (itemExpand) {
          value = itemExpand;
          item.expanded = true;
        }
      }
    });
  }

  return value;
};





type WsSalesSearchItemsProps = {
  searchValue: string;
  setSearchValue: React.Dispatch<React.SetStateAction<string>>
  items: WsSalesSolutionItem[];
  setItems: React.Dispatch<React.SetStateAction<WsSalesSolutionItem[]>>;
  setSearchItemId: React.Dispatch<React.SetStateAction<string | undefined>>;
};

const WsSalesSearchItems = (props: WsSalesSearchItemsProps) => {

  const itemList = getChildItemsFromTopLevelItems(props.items, 'capabilities', { includeChildCapabilities: true }) as [ WsSalesSolutionItem, WsSalesSolutionItem | WsSalesSolutionAction, string ][];

  const elementList = itemList.map((i, index: number) => {

    const item = i[0];

    if (item && item.name && item.name.toLowerCase().indexOf(`${props.searchValue}`.toLowerCase()) > -1) {

      const selected = getItemSelected(item);

      return (
        <div
          className="ws-sales-solution-view-search-item"
          key={`${item.id}-${index}`}
          data-expand={true}
          onClick={(ev: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
            if (ev.target instanceof HTMLDivElement) {
              if (!ev.target.classList.contains('ms-Checkbox') && !ev.target.classList.contains('ms-Checkbox-checkbox')) {
                const newItems = [ ...props.items ];

                expandItems(props.items, item.id);

                props.setSearchItemId(item.id);

                props.setItems(newItems);

                setTimeout(() => {
                  props.setSearchValue('');
                }, 100);
              }
            }
          }}
        >
          <div className="ws-sales-solution-view-search-item-select" style={{ paddingRight: 0 }}>
            <Checkbox
              data-expand={false}
              // indeterminate={selected === -1 ? true : false }
              checked={selected === 1 ? true : false }
              onChange={(ev?: React.FormEvent<HTMLElement | HTMLInputElement> | undefined, checked?: boolean | undefined): void => {
                const newItems = [ ...props.items ];

                // item.selected = selected === 1 ? false : true;

                setItemSelected(selected === 1 ? false : true, item, 'scope', newItems, { selectChildCapabilities: false });

                props.setItems(newItems);
              }}
            />
          </div>
          <div className="ws-sales-solution-view-search-item-name">
            <ItemNameWithSearch
              name={item.name}
              search={props.searchValue}
              item={item}
              items={props.items}
              setItems={props.setItems}
              mode="scope"
            />
          </div>
          <div className="ws-sales-solution-view-search-item-select">
            <Checkbox
              data-expand={false}
              // indeterminate={selected === -1 ? true : false }
              checked={selected === 1 ? true : false }
              onChange={(ev?: React.FormEvent<HTMLElement | HTMLInputElement> | undefined, checked?: boolean | undefined): void => {
                const newItems = [ ...props.items ];

                setItemSelected(selected === 1 ? false : true, item, 'scope', newItems, { selectChildCapabilities: true });

                props.setItems(newItems);
              }}
              label="ALL"
            />
          </div>
          <div className="ws-sales-solution-view-search-item-goto">
            <div className="ws-sales-solution-view-search-item-goto-button">
              GO TO
            </div>
          </div>
          <div className="ws-sales-solution-view-search-item-path">
            {getItemPath(props.items, item)}
          </div>
        </div>
      );

    } else {
      return null;
    }
  }).filter(el => el);

  if (elementList.length > 0) {
    return (
      <div className="ws-sales-solution-view-search-items ws-scroll ws-scroll-y">
        {elementList}
      </div>
    );
  } else {
    return (
      <div className="ws-sales-solution-view-search-items ws-scroll ws-scroll-y">
        <div style={{ padding: '20px 10px', textAlign: 'center' }}>
          No capabilities found!
        </div>
      </div>
    );
  }
};




type WsSalesSearchBoxProps = {
  items: WsSalesSolutionItem[];
  setItems: React.Dispatch<React.SetStateAction<WsSalesSolutionItem[]>>;
  setSearchItemId: React.Dispatch<React.SetStateAction<string | undefined>>;
};

const WsSalesSearchBox = (props: WsSalesSearchBoxProps) => {

  const [ focus, setFocus ] = useState<boolean>(false);

  const [ searchValue, setSearchValue ] = useState<string>('');

  return (
    <div className="ws-sales-solution-view-search">
      <SearchBox
        // styles={searchBoxStyles}
        placeholder="Search"
        // onEscape={(ev?: any) => {
        //   console.log('Custom onEscape Called');
        // }}
        // onClear={(ev?: any) => {
        //   console.log('Custom onClear Called');
        // }}
        onChange={(event?: React.ChangeEvent<HTMLInputElement> | undefined, newValue?: string | undefined) => {

          // console.clear();

          if (newValue || newValue === '') {
            setFocus(true);
            setSearchValue(newValue);
          }

        }}
        // onSearch={(newValue: any) => {
        //   console.log('SearchBox onSearch fired: ' + newValue);
        // }}
        onFocus={() => {
          setFocus(true);
        }}
        onBlur={(ev) => {
          console.log(ev.currentTarget);
          console.log(ev.target);
          setTimeout(() => {
            // setFocus(false);
            // setSearchValue('');
          }, 500);
        }}
        value={searchValue}
      />

      {
        focus
        &&
        searchValue
        &&
        <WsSalesSearchItems
          searchValue={searchValue}
          setSearchValue={setSearchValue}
          items={props.items}
          setItems={props.setItems}
          setSearchItemId={props.setSearchItemId}
        />
      }
    </div>);
};







type WsSalesSolutionViewProps = {
  items: WsSalesSolutionItem[];
  setItems: React.Dispatch<React.SetStateAction<WsSalesSolutionItem[]>>;
  mode: string;
  avanade: boolean;
};

const WsSalesSolutionView = ({ items, setItems, mode, avanade }: WsSalesSolutionViewProps) => {

  const appContext = useContext(WsAppContext);

  const panelContext = useContext(WsPanelContext);

  const [ searchItemId, setSearchItemId ] = useState<string | undefined>(undefined);

  const permissionLevelParnerSubmit = [ 'PARTNER_SUBMIT' ].includes(getPermissionLevel('sales/solution', appContext?.role));
  const permissionLevelFull =         [ 'FULL'           ].includes(getPermissionLevel('sales/solution', appContext?.role));


  useEffect(() => {

    if (searchItemId) {
      setTimeout(() => {
        // setSearchItemId(undefined);
      }, 5000);
    }

  }, [ searchItemId ]);



  const [ moveItem, setMoveItem ] = useState<WsSalesSolutionItem | undefined>(undefined);



  return (
    <div className="ws-sales-solution-view">

      <WsSalesSolutionViewContext.Provider
        value={{  
          moveItem,
          setMoveItem
        }}
      >

        {
          mode === 'scope'
          &&
          <WsSalesSearchBox
            items={items}
            setItems={setItems}
            setSearchItemId={setSearchItemId}
          />
        }

        {
          (mode === 'size' || mode === 'rom')
          &&
          <div className="ws-sales-solution-view-top" style={{ marginRight: getBlockRightMargin(items, 0, mode) }}>



            <div className="ws-sales-solution-view-top-left"></div>



            {
              mode === 'size'
              &&
              <div className="ws-sales-solution-box-size">
                <WsItemSizeTooltip size="S">
                  <Checkbox
                    // label="S"
                    checked={getItemSizeAll(items, 'S', mode)}
                    onChange={(ev?: React.FormEvent<HTMLElement | HTMLInputElement> | undefined, checked?: boolean | undefined) => {
                      setItemSizeAll(items, setItems, 'S', mode);
                    }}
                  />
                </WsItemSizeTooltip>

                <WsItemSizeTooltip size="M">
                  <Checkbox
                    // label="M"
                    checked={getItemSizeAll(items, 'M', mode)}
                    onChange={(ev?: React.FormEvent<HTMLElement | HTMLInputElement> | undefined, checked?: boolean | undefined) => {
                      setItemSizeAll(items, setItems, 'M', mode);
                    }}
                  />
                </WsItemSizeTooltip>

                <WsItemSizeTooltip size="C">
                  <Checkbox
                    // label="C"
                    checked={getItemSizeAll(items, 'C', mode)}
                    onChange={(ev?: React.FormEvent<HTMLElement | HTMLInputElement> | undefined, checked?: boolean | undefined) => {
                      setItemSizeAll(items, setItems, 'C', mode);
                    }}
                  />
                </WsItemSizeTooltip>

                <WsItemSizeTooltip size="VC">
                  <Checkbox
                    // label="VC"
                    checked={getItemSizeAll(items, 'VC', mode)}
                    onChange={(ev?: React.FormEvent<HTMLElement | HTMLInputElement> | undefined, checked?: boolean | undefined) => {
                      setItemSizeAll(items, setItems, 'VC', mode);
                    }}
                  />
                </WsItemSizeTooltip>

                <div style={{
                  display: 'inline-block',
                  width: 21,
                  height: 14
                }}></div>
              </div>
            }



            {
              mode === 'rom'
              &&
              <div className="ws-sales-solution-box-rom">
                <div className="ws-sales-solution-box-rom-size">Size</div>
                <div className="ws-sales-solution-box-rom-effort">Effort</div>
                <div className="ws-sales-solution-box-rom-team">Team</div>
              </div>
            }

          </div>
        }

        <WsSalesSolutionBlockContainer
          items={items}
          setItems={setItems}
          mode={mode}
          level={1}
          levelItems={items}
          avanade={avanade}
          searchItemId={searchItemId}
        />

        {
          moveItem
          &&
          <WsSelectItemDialog
            title={`Move ${moveItem.name} (Capability)`}
            label="Target:"
            items={items}
            selectAction={false}
            close={() => {
              setMoveItem(undefined);
            }}
            continue={(selectedItem: WsSalesSolutionItem | WsSalesSolutionAction | undefined) => {

              if (selectedItem) {

                const moveItemFind = findItemById(items, moveItem.id, '', {});

                const nextItems = [ ...items ];

                if (moveItemFind && moveItemFind.parent && moveItemFind.parent.items && Array.isArray(moveItemFind.parent.items)) {

                  // remove

                  console.log(moveItemFind.parent.name);

                  console.log(moveItemFind.parent.items);

                  moveItemFind.parent.items = moveItemFind.parent.items.filter((i) => i.id !== moveItem.id);

                  console.log(moveItemFind.parent.items);

                  // add

                  if (itemIsAction(selectedItem)) {
                  } else {

                    if (selectedItem.items) {
                      selectedItem.items = [ ...selectedItem.items, moveItem ];
                    } else {
                      selectedItem.items = [ moveItem ];
                    }

                    setItemProperty(moveItem, (i) => {
                      i.areaId = selectedItem.areaId;
                    });
                  }
                }

                setItems(nextItems);
              }

              setMoveItem(undefined);
            }}
          />
        }

      </WsSalesSolutionViewContext.Provider>

    </div>
  );
};




export {
  getAllMetrics,       // TODO: move to helpers
  getAllMetricsByItem, // TODO: move to helpers
  WsSalesSolutionView
};
